import { IconNames } from '@blueprintjs/icons';
import { type RadioButtonOption } from '@strata/react-radio-button-group';
import { TextWithIcon } from '@strata/react-status-icons';

export const PBMOnlyOptions = [
    {
        value: 'true',
        component: <TextWithIcon icon={IconNames.SHIELD} text="PBM Only" />,
    },
    {
        value: 'false',
        text: 'PBM & Payer',
    },
] as RadioButtonOption[];
